<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش هنرجویان</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="3" sm="12" md="3" lg="3">
            <v-autocomplete color="black" v-model="order" label="نوع ترتیب کاربران را انتخاب کنید" :items="orderItems"
                            item-text="name" @change="getStudents"></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-text-field color="black" label="نام یا نام خانوادگی را وارد کنید." v-model="needle">
            </v-text-field>
          </v-col>
          <v-col cols="3">
            <v-autocomplete label="آموزشگاه" :items="schools" item-text="label" item-value="id"
                            color="black" v-model="filter.school_id">
            </v-autocomplete>
          </v-col>
          <v-col cols="2">
            <v-checkbox label="اشتراک فعال" color="black" v-model="filter.subscription"></v-checkbox>
          </v-col>
          <v-radio-group v-model="filter.subscriptionPeriod" row>
            <v-radio label="اشتراک در ۳ روز گذشته تمام شده" value="ended_subscription_in_last_three_days"></v-radio>
            <v-radio label="اشتراک در ۳ روز آینده تمام می شود" value="ended_subscription_in_next_three_days"></v-radio>
          </v-radio-group>
          <v-col cols="2">
            <v-btn block color="primary" @click="getStudents">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/students/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات هنرجویان</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/students/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت هنرجوی جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="students.data"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.profile_image`]="{ item }">
                <v-img :src="item.profile_image" width="70" height="60" class="mr-16"></v-img>
              </template>
              <template
                  v-slot:[`item.subscription_count`]="{ item }">
                {{ item.valid_subscriptions.length }}
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/students/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
                <v-icon class="mx-1" color="primary" @click="openChargeDialog(item.id)">mdi-currency-usd</v-icon>
                <v-icon class="mx-1" color="success" @click="$router.push('/students/get/'+item.id)">mdi-eye</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="students.current_page"
                :length="students.last_page"
                circle
                @input="getStudents"
            ></v-pagination>
          </v-col>
          <v-col cols="12" class="text-center">
            {{ students.total }} تا
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این هنرجو اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          ta
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="chargeDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            ویرایش موجودی حساب هنرجو
          </v-col>
          <v-col cols="6">
            <v-text-field color="black" v-model="description" label="جزییات">
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field color="black" v-model="amount" label="مبلغ">
            </v-text-field>
          </v-col>
          <v-col cols="12">
            <v-btn color="success" @click="editCharge()">
              ویرایش
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "StudentIndex",
  data() {
    return {
      schools: [],
      needle: null,
      selectedEntityId: null,
      deleteDialog: false,
      chargeDialog: false,
      loading: true,
      amount: 0,
      description: null,
      orderItems: [
        {name: 'بر اساس وضعیت', value: 'status'},
        {name: 'بر اساس جنسیت', value: 'gender'},
        {name: 'بر اساس تاریخ ثبت نام', value: 'created_at'},
        {name: 'بر اساس تاریخ تولد', value: 'birth_date'},
      ],
      order: 'created_at',
      students: {
        current_page: 1
      },
      filter: {
        subscription: false,
        school_id: null,
        subscriptionPeriod: null,
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'موجودی', value: 'balance', align: 'center'},
        {text: 'ایمیل', value: 'email', align: 'center'},
        {text: 'تاریخ ثبت نام', value: 'register_date_fa', align: 'center'},
        {text: 'تاریخ تولد', value: 'birth_date_fa', align: 'center'},
        {text: 'جنسیت', value: 'gender_label', align: 'center'},
        {text: 'شماره همراه', value: 'mobile', align: 'center'},
        {text: 'عکس پروفایل', value: 'profile_image', align: 'center'},
        {text: 'استان', value: 'state_name', align: 'center'},
        {text: 'شهر', value: 'city_name', align: 'center'},
        {text: 'مدرسه', value: 'school_label', align: 'center'},
        {text: 'وضعیت', value: 'status_label', align: 'center'},
        {text: 'آخرین بازدید', value: 'last_visit_fa', align: 'center'},
        {text: 'تعداد اشتراک', value: 'subscription_count', align: 'center'},
        {text: 'اشتراک تا', value: 'subscription_active_until_fa', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getStudents()
    this.getSchools()
  },
  methods: {
    getSchools() {
      window.axios.get('school/admin-index').then((res) => {
        this.schools = res.data.data
      })
    },
    finalDestroy() {
      window.axios.delete('admin/student/delete/' + this.selectedEntityId).then(() => {
        this.getStudents()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    getStudents() {
      let url = 'admin/student/index?page=' + this.students.current_page ?? 1
      url = url + '&order=' + this.order
      if (this.needle) {
        url = url + '&needle=' + this.needle
      }
      if (this.filter.subscription) {
        url = url + '&subscription=true'
      }
      if (this.filter.school_id) {
        url = url + '&school_id=' + this.filter.school_id
      }
      if (this.filter.subscriptionPeriod) {
        url = url + '&subscription_period=' + this.filter.subscriptionPeriod
      }
      window.axios.get(url).then((res) => {
        this.students = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(studentId) {
      this.selectedEntityId = studentId
      this.deleteDialog = true
    },
    openChargeDialog(studentId) {
      this.selectedEntityId = studentId
      this.chargeDialog = true
    },
    editCharge() {
      window.axios.post('finance/wallet/edit/', {
        student_id: this.selectedEntityId,
        description: this.description,
        amount: this.amount
      }).then((res) => {
        this.chargeDialog = false
        console.log(res.data.data)
        this.openSnackbar(res.data.message, 'success')
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }

  }
}
</script>

<style scoped>

</style>
